/**
 * 檔案用途區塊
 * @module Show
 * @purpose 提供條件渲染元件，於條件成立時顯示 children，否則顯示備援內容。
 */
import { IBaseComponentProp } from '@shared/interfaces/base-component.interface';
import React from 'react';

interface Props extends IBaseComponentProp {
  fallbackSlot?: Slot;
  fallback?: React.ReactNode;
  when: boolean;
}

/**
 * 宣告內容用途說明與單號關聯
 * @description Show 元件主體。
 * @purpose 依據 when 條件切換渲染 children 與 fallbackSlot/fallback，簡化呼叫端 JSX 判斷邏輯。
 */
const Show = ({ when, fallback, fallbackSlot, children }: Props) => {
  return <>{when ? children : (fallbackSlot?.() ?? fallback)}</>;
};
export default Show;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:21:23.680Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/middle/bottom) in Chinese titles, used mandated tags, omitted @external where no ticket exists, and kept runtime code unchanged.
 */
